"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscordRelayMessageHistoryMessagesToJSON = exports.DiscordRelayMessageHistoryMessagesFromJSONTyped = exports.DiscordRelayMessageHistoryMessagesFromJSON = void 0;
var runtime_1 = require("../runtime");
function DiscordRelayMessageHistoryMessagesFromJSON(json) {
    return DiscordRelayMessageHistoryMessagesFromJSONTyped(json, false);
}
exports.DiscordRelayMessageHistoryMessagesFromJSON = DiscordRelayMessageHistoryMessagesFromJSON;
function DiscordRelayMessageHistoryMessagesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'channelId': !(0, runtime_1.exists)(json, 'channelId') ? undefined : json['channelId'],
        'guildId': !(0, runtime_1.exists)(json, 'guildId') ? undefined : json['guildId'],
        'content': !(0, runtime_1.exists)(json, 'content') ? undefined : json['content'],
        'timestamp': !(0, runtime_1.exists)(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'author': !(0, runtime_1.exists)(json, 'author') ? undefined : json['author'],
    };
}
exports.DiscordRelayMessageHistoryMessagesFromJSONTyped = DiscordRelayMessageHistoryMessagesFromJSONTyped;
function DiscordRelayMessageHistoryMessagesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'channelId': value.channelId,
        'guildId': value.guildId,
        'content': value.content,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'author': value.author,
    };
}
exports.DiscordRelayMessageHistoryMessagesToJSON = DiscordRelayMessageHistoryMessagesToJSON;
